<template>
	<div>
		<v-app-bar flat height="100">
			<v-img src="/public/sublet.svg" height="64" max-width="64" class="ml-4" alt="Sublet logo" />
			<v-toolbar-title>
				<div class="d-flex align-center text-no-wrap py-4">
					<div class="d-flex boldonse-regular text-yellow-darken-2" :style="$route.path === '/' ? 'cursor: default' : 'cursor: pointer'" @click="$router.push({ path: '/' })">
						<div class="sub-stylized">Sub</div>
						<div>let</div>
					</div>
					<div v-show="!xs" class="saira-extra-condensed-regular ml-4" style="font-size: 1.75rem">{{ headerTitle.text }}</div>
				</div>
			</v-toolbar-title>

			<div v-for="menu of menus" class="d-flex align-center mr-2">
				<v-menu v-if="!xs && menu.name === 'info'">
					<template v-slot:activator="{ props, isActive }">
						<v-btn variant="text" v-bind="props" :append-icon="isActive ? 'chevron-up' : 'chevron-down'">
							<span class="text-caption">{{ menu.name }}</span>
							<template v-slot:prepend>
								<v-icon :icon="menu.icon" />
							</template>
						</v-btn>
					</template>
					<v-list>
						<v-list-item v-for="(item, index) in items[menu.name]" :key="index" :value="index" :href="item.href" rel="noopener noreferrer" target="_blank" density="compact">
							<template v-slot:prepend>
								<v-img v-if="item.img" :src="item.img" width="36" class="mr-9" cover alt="Link logo" />
								<v-icon v-else :icon="item.icon" size="small" />
							</template>
							<v-list-item-title class="saira-extra-condensed-light">{{ item.title }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-chip v-else-if="menu.name === 'user' && username" label rounded class="pl-0 rounded-ts-xl rounded-bs-xl rounded-e-xl">
					<v-avatar class="text-caption font-weight-bold text-capitalize" color="white" :text="username?.slice(0, 2)" />
				</v-chip>
			</div>
			<v-app-bar-nav-icon variant="plain" @click.stop="drawer = !drawer" class="mr-4" />
		</v-app-bar>

		<v-navigation-drawer v-model="drawer" temporary location="right">
			<v-list>
				<v-list-item v-for="(item, index) in items.side.filter(i => !i.filter)" :key="index" :value="index" :to="item.to" :href="item.href" @click="() => item.action && item.action($emit)">
					<template v-slot:prepend>
						<v-icon :icon="item.icon" />
					</template>
					<v-list-item-title class="saira-extra-condensed-light text-end py-2">{{ item.title }}</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>
<style scoped>
.sub-stylized {
	transform-origin: bottom;
	transform: scaleY(0.5);
}
:deep(.v-list-.v-icon) {
	font-size: 0.75rem !important;
}
</style>
<script setup>
import { ref, getCurrentInstance, computed } from 'vue'
import { useDisplay } from 'vuetify/lib/framework.mjs'
import { useRoute } from 'vue-router'

defineEmits(['open:apikeys'])
const props = defineProps({
	username: String,
})
const route = useRoute()
const { xs } = useDisplay()
const { $keycloak, $emitter } = getCurrentInstance().appContext.config.globalProperties
const { login, logout } = $keycloak.value
const drawer = ref(false)
// prettier-ignore
const headerTitles = ref({
    developers: [
        { text: 'Subdomains as a Service - True SaaS!' },
        { text: 'Programmatically Lease & Delegate Subdomains' },
        { text: 'Flexible Subdomain Routing for Hackers and Makers' },
        { text: 'One Domain, Infinite Deployments' }
    ],
    public: [
        { text: 'Domain taken? With Sublet, opportunity is still available!' },
        { text: 'Subdomain Registration – Claim Your Digital Corner' },
        { text: 'Build Your Brand on a Bigger Name' },
        { text: 'Subdomains that Work for You' },
        { text: 'Affordable Identity. Global Reach.' },
    ]
})
const headerTitle = computed(() => {
	const category = /\/account/.test(route.path) ? 'public' : 'developers'
	const randomCategoryIndex = Math.floor(Math.random() * headerTitles.value[category].length)
	const randomCategory = headerTitles.value[category][randomCategoryIndex]

	return randomCategory
})
const menus = ref([
	{
		name: 'user',
		icon: 'fas user',
	},
	{
		name: 'info',
		icon: 'fas fa-circle-info',
	},
])
const items = computed(() => ({
	side: [
		{
			title: $keycloak.value.isAuthenticated ? 'sign out' : 'sign in',
			action: $keycloak.value.isAuthenticated ? logout : login,
			icon: $keycloak.value.isAuthenticated ? 'fa-arrow-right-from-bracket' : 'fa-arrow-right-to-bracket',
		},
		{
			title: 'account',
			to: '/account',
			icon: 'user',
			filter: !$keycloak.value.isAuthenticated || /\/account/.test(route.path),
		},
		{
			title: 'home',
			to: '/',
			icon: 'home',
		},
		{
			title: 'api keys',
			action: () => $emitter.emit('open:apikeys'),
			icon: 'key',
			filter: !$keycloak.value.isAuthenticated || !/\/account/.test(route.path),
		},
		{
			title: 'support',
			href: 'https://github.com/june07/sublet/issues',
			icon: 'headset',
		},
	],
	info: [
		{
			title: 'about Sublet',
			href: 'https://blog.june07.com/sublet/',
			icon: 'blog',
		},
		{
			title: 'GitHub',
			href: 'https://github.com/june07/sublet/wiki/What-is-Sublet%3F',
			img: '/github-mark.svg',
		},
		{
			title: 'support',
			href: 'https://github.com/june07/sublet/issues',
			icon: 'headset',
		},
	],
	account: [
		{
			title: $keycloak.value.isAuthenticated ? 'sign out' : 'sign in',
			action: $keycloak.value.isAuthenticated ? logout : login,
			icon: $keycloak.value.isAuthenticated ? 'fa-arrow-right-from-bracket' : 'fa-arrow-right-to-bracket',
		},
		{
			title: 'support',
			href: 'https://github.com/june07/sublet/issues',
			icon: 'headset',
		},
	],
}))
</script>
